/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskForm990ScheduleAPartVI
 */
export interface ExecRiskForm990ScheduleAPartVI {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990ScheduleAPartVI
     */
    FormAndLineReferenceDesc?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990ScheduleAPartVI
     */
    ExplanationTxt?: string;
}

/**
 * Check if a given object implements the ExecRiskForm990ScheduleAPartVI interface.
 */
export function instanceOfExecRiskForm990ScheduleAPartVI(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskForm990ScheduleAPartVIFromJSON(json: any): ExecRiskForm990ScheduleAPartVI {
    return ExecRiskForm990ScheduleAPartVIFromJSONTyped(json, false);
}

export function ExecRiskForm990ScheduleAPartVIFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskForm990ScheduleAPartVI {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'FormAndLineReferenceDesc': !exists(json, 'FormAndLineReferenceDesc') ? undefined : json['FormAndLineReferenceDesc'],
        'ExplanationTxt': !exists(json, 'ExplanationTxt') ? undefined : json['ExplanationTxt'],
    };
}

export function ExecRiskForm990ScheduleAPartVIToJSON(value?: ExecRiskForm990ScheduleAPartVI | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'FormAndLineReferenceDesc': value.FormAndLineReferenceDesc,
        'ExplanationTxt': value.ExplanationTxt,
    };
}

